import { render, staticRenderFns } from "./PendingReceiveList.vue?vue&type=template&id=ce9ad654"
import script from "./PendingReceiveList.vue?vue&type=script&lang=js"
export * from "./PendingReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports